import React from 'react'
import { Link } from 'react-router-dom'
import { isBraveBrowser } from '../../utils/labelPrinter'

// The lp destination name macOS assigns the ZD421 when added via CUPS.
const LP_COMMAND = (filename) => `lp -d Zebra_ZD421_Printer -o raw ~/Downloads/${filename}`

/**
 * Shown when a label print is attempted but Zebra Browser Print is not
 * detected. Offers the raw .zpl download plus the one-line Terminal command
 * to send it, so printing is never fully blocked on the agent.
 */
function PrintFallbackDialog({ zpl, filename, onClose }) {
  function handleDownload() {
    const blob = new Blob([zpl], { type: 'text/plain;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = filename
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
    URL.revokeObjectURL(url)
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: 560 }}>
        <div className="modal-header">
          <h2>Zebra Browser Print not detected</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div style={{ padding: 'var(--space-4)' }}>
          <p className="text-sm text-muted" style={{ marginBottom: 'var(--space-4)' }}>
            The Browser Print agent isn't running on this machine, so the label can't be
            sent to the printer directly. You can still print it:
          </p>

          {isBraveBrowser() && (
            <div
              style={{
                background: '#fffbeb',
                border: '1px solid #fde68a',
                borderRadius: 'var(--radius-sm)',
                padding: 'var(--space-3)',
                marginBottom: 'var(--space-4)'
              }}
            >
              <p className="text-sm" style={{ fontWeight: 600, marginBottom: 'var(--space-1)' }}>
                Using Brave? The agent may be running but blocked.
              </p>
              <p className="text-sm" style={{ marginBottom: 'var(--space-2)' }}>
                Brave stops web pages reaching localhost by default. Paste this into the
                address bar, add <code>https://prism-commerce.com</code> to the allowed
                list, then reload and print again:
              </p>
              <pre
                style={{
                  background: 'var(--color-gray-100)',
                  padding: 'var(--space-2)',
                  borderRadius: 'var(--radius-sm)',
                  fontSize: 12,
                  userSelect: 'all',
                  margin: 0
                }}
              >brave://settings/content/localhostAccess</pre>
            </div>
          )}

          <div style={{ marginBottom: 'var(--space-4)' }}>
            <button className="btn btn-primary" onClick={handleDownload}>
              Download {filename}
            </button>
            <p className="text-sm text-muted" style={{ marginTop: 'var(--space-2)' }}>
              Then send it to the printer from Terminal:
            </p>
            <pre
              style={{
                background: 'var(--color-gray-100)',
                padding: 'var(--space-3)',
                borderRadius: 'var(--radius-sm)',
                fontSize: 12,
                overflowX: 'auto',
                userSelect: 'all'
              }}
            >{LP_COMMAND(filename)}</pre>
          </div>

          <p className="text-sm">
            To print with one click in future,{' '}
            <Link to="/inventory/printing" onClick={onClose}>
              install Zebra Browser Print — setup notes here
            </Link>.
          </p>
        </div>
      </div>
    </div>
  )
}

export default PrintFallbackDialog
